module.exports = __webpack_public_path__ + "img/blankscreen_300.ff81403e.png";